/*
 * Copyright (C) 2014 Spanning Cloud Apps.  All rights reserved.
 */
import './account.tpl.html';

angular.module('account', ['ui.router', 'sbsf.constants', 'sbsf.enums']).config([
  '$stateProvider',
  'VIEW_STATES',
  function ($stateProvider, VIEW_STATES) {
    $stateProvider.state(VIEW_STATES.ACCOUNT, {
      url: '/account',
      views: {
        content: {
          templateUrl: 'account/account.tpl.html'
        }
      }
    });
  }
]);
